// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:48:56

export default {
  "id": "hidden-object-clues-and-mysteries",
  "slug": "hidden-object-clues-and-mysteries",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/cc01f5db481e48898014c0a8bfb802cc-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/cc01f5db481e48898014c0a8bfb802cc/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Hidden Object: Clues and Mysteries",
      "description": "Hidden Object: Clues and Mysteries is a relaxing hidden object game set in cozy interiors. Solve mysteries with a detective, accompanied by soothing melodies.",
      "instructions": "In the game, you can freely move left and right across locations and zoom in to find hidden objects.\n\nThe game is available on both PC and mobile devices, allowing you to play anytime, anywhere.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "1player",
        "collect",
        "detective",
        "hidden",
        "timekiller"
      ]
    },
    "zh-CN": {
      "title": "隐藏物体：线索与谜团",
      "description": "《隐藏物体：线索与谜团》是一款轻松的隐藏物体游戏，设定在舒适的室内环境中。与侦探一起解开谜团，伴随着舒缓的音乐。",
      "instructions": "在游戏中，您可以自由地在各个地点左右移动，并放大寻找隐藏的物品。\n\n该游戏可在PC和移动设备上使用，让您随时随地随时游玩。",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "1玩家",
        "收集",
        "侦探",
        "隐藏",
        "时间杀手"
      ]
    },
    "zh-TW": {
      "title": "隱藏對象：線索與謎團",
      "description": "隱藏對象：線索與謎團是一款舒緩的隱藏對象遊戲，設置在舒適的室內。與侦探一起解開謎團，並伴隨著輕鬆的旋律。",
      "instructions": "在遊戲中，您可以自由地在各處左右移動，並放大尋找隱藏的物品。\n\n該遊戲可在PC和移動設備上遊玩，讓您隨時隨地都能遊戲。",
      "genres": [
        "休闲",
        "拼圖"
      ],
      "tags": [
        "1玩家",
        "收集",
        "警探",
        "隱藏",
        "時間消磨者"
      ]
    },
    "zh-HK": {
      "title": "隱藏物體：線索與謎團",
      "description": "隱藏物：線索與謎團是一個設於舒適內室的輕鬆隱藏物遊戲。與偵探一起解謎，並伴隨著寧靜的旋律。",
      "instructions": "遊戲中，你可以自由地在各個地點左右移動，並放大鏡頭尋找隱藏的物品。\n\n此遊戲可在電腦及手機設備上玩，讓你可以隨時隨地進行遊戲。",
      "genres": [
        "輕鬆",
        "謎題"
      ],
      "tags": [
        "1玩家",
        "收集",
        "警探",
        "隱藏",
        "時間殺手"
      ]
    },
    "ja": {
      "title": "隠し物探しゲーム：ヒントと謎",
      "description": "隠し物：ヒントと謎は、落ち着いたインテリアに設置されたリラックスした隠し物ゲームです。優しいメロディに乗せて、探偵と一緒に謎を解きましょう。",
      "instructions": "ゲームでは、自由に場所を左右に移動し、隠れたオブジェクトを見つけるためにズームインすることができます。\n\nこのゲームはPCおよびモバイルデバイスの両方で利用可能で、いつでもどこでも遊ぶことができます。",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "収集",
        "探偵",
        "隠された",
        "時間殺人者"
      ]
    },
    "ko": {
      "title": "숨겨진 오브젝트: 증거와 미스터리",
      "description": "히든 오브젝트: 클루즈 앤 미스터리는 편안한 인테리어에서 즐길 수 있는 휴식적인 히든 오브젝트 게임입니다. 멋진 멜로디와 함께 탐정과 함께 미스터리를 해결하세요.",
      "instructions": "게임에서는 위치를 좌우로 자유롭게 이동하고 숨겨진 물체를 찾기 위해 줌인할 수 있습니다.\n\n이 게임은 PC와 모바일 기기 모두에서 사용할 수 있어 언제 어디서나 즐길 수 있습니다.",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "1플레이어",
        "수집",
        "탐정",
        "숨겨진",
        "시간쟁이"
      ]
    },
    "fr": {
      "title": "Objet caché : Clues et Mystères",
      "description": "Objet caché : Clues and Mysteries est un jeu de quête d'objets cachés apaisant, se déroulant dans des intérieurs cocooning. Résolvez des mystères avec un détective, accompagné de mélodies apaisantes.",
      "instructions": "Dans le jeu, vous pouvez vous déplacer librement à gauche et à droite entre les lieux et zoomer pour trouver des objets cachés.\n\nLe jeu est disponible sur PC et appareils mobiles, ce qui vous permet de jouer n'importe quand et n'importe où.",
      "genres": [
        "Facile",
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "collecter",
        "détective",
        "caché",
        "temps tueur"
      ]
    }
  }
};
